import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdminEmail } from '../config/adminConfig';

const AdminGuard = ({ children }) => {
  const navigate = useNavigate();
  const { currentUser, loading, authInitialized } = useAuth();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Don't check until auth is initialized
    if (!authInitialized || loading) {
      return;
    }

    const checkAdminAccess = () => {
      // Check Firebase Auth user - use centralized admin config
      const isFirebaseAdmin = currentUser && currentUser.email && isAdminEmail(currentUser.email);
      
      // ONLY allow Firebase Auth admin access (required for Firestore rules)
      if (isFirebaseAdmin) {
        setIsChecking(false);
        return;
      }
      
      // If no admin access, redirect to login
      navigate('/admin/login');
      setIsChecking(false);
    };

    // Small delay to ensure state is stable
    const timeoutId = setTimeout(checkAdminAccess, 100);
    
    return () => clearTimeout(timeoutId);
  }, [currentUser, loading, authInitialized, navigate]);

  // Show loading while checking authentication
  if (loading || isChecking || !authInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #d4af37',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p>Verifying admin credentials...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return children;
};

export default AdminGuard;
